import path from "./path";

export const navigation = [
    {
        id: 0,
        value: "HOME",
        path: `/${path.HOME}`,
    },
    {
        id: 1,
        value: "PRODUCTS",
        path: `/${path.PRODUCTS}`,
    },
    // {
    //     id: 2,
    //     value: "BLOGS",
    //     path: `/${path.BLOGS}`,
    // },
    {
        id: 3,
        value: "SERVICES",
        path: `/${path.SERVICES}`,
    },
    {
        id: 4,
        value: "FAQs",
        path: `/${path.FAQs}`,
    },
];
